import { render, staticRenderFns } from "./ProvideMissingInformation.vue?vue&type=template&id=13ba3b8a"
import script from "./ProvideMissingInformation.vue?vue&type=script&lang=js"
export * from "./ProvideMissingInformation.vue?vue&type=script&lang=js"
import style0 from "./ProvideMissingInformation.vue?vue&type=style&index=0&id=13ba3b8a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ba3b8a')) {
      api.createRecord('13ba3b8a', component.options)
    } else {
      api.reload('13ba3b8a', component.options)
    }
    module.hot.accept("./ProvideMissingInformation.vue?vue&type=template&id=13ba3b8a", function () {
      api.rerender('13ba3b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/ProvideMissingInformation.vue"
export default component.exports